// extracted by mini-css-extract-plugin
export default {"mainText":"Bodytext_mainText__hIGKq","Textwrapper":"Bodytext_Textwrapper__FL66x","Textwrapper2":"Bodytext_Textwrapper2__ZLKJk","Textwrapper3":"Bodytext_Textwrapper3__zE2Ca"};